import { Density } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';
import Focusable, { FocusEventListener } from '@philips-emr/tws-core/lib/component/types/focusable';

export interface RadioOption {
  key: string;
  label: string;
  value: string;
}

class RadioGroupAPI extends ComponentAPI implements Changeable<string>, Focusable {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<string>();

  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

  getName(): string {
    return this.state.name;
  }

  setName(name: string): void {
    this.setState({ name });
  }

  isEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  setFocus(focused: boolean): void {
    this.setState({ focused });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  getDensity(): Density {
    return this.state.density;
  }

  setDensity(density: Density): void {
    this.setState({ density });
  }

  getData(): RadioOption[] {
    return this.state.data;
  }

  setData(data: RadioOption[]): void {
    this.setState({ data });
  }

}

export default RadioGroupAPI;
